module.exports = __webpack_public_path__ + "static/ob_mukai-95cdc6eff1ca1a67b15a8a5203f34ac7.jpg";